module.exports = __webpack_public_path__ + "static/media/siegel2025.3f5d2830.png";